import { Avatar, Dropdown, Menu } from "antd";
import React from "react";

export const User = ({
  logoutFunc,
  user,
}: {
  logoutFunc: () => void;
  user: string;
}) => {
  const menu = (
    <Menu>
      <Menu.Item key="logout" onClick={() => logoutFunc()}>
        Выйти
      </Menu.Item>
    </Menu>
  );
  return (
    <div style={{ float: "right" }}>
      <Dropdown overlay={menu} placement="bottomLeft">
        <Avatar style={{ backgroundColor: "#67c4ac" }} size={34}>
          {user}
        </Avatar>
      </Dropdown>
    </div>
  );
};
